export const UPDATE_MODAL_SIZE = "UPDATE_MODAL_SIZE";
export type UPDATE_MODAL_SIZE = typeof UPDATE_MODAL_SIZE;

export const SWITCH_MODAL_SIZE = "SWITCH_MODAL_SIZE";
export type SWITCH_MODAL_SIZE = typeof SWITCH_MODAL_SIZE;

export const UPDATE_AUTH = "UPDATE_AUTH";
export type UPDATE_AUTH = "UPDATE_AUTH";

export const UPDATE_SRP_LINK = "UPDATE_SRP_LINK";
export type UPDATE_SRP_LINK = "UPDATE_SRP_LINK";

export const UPDATE_USER_NAME = "UPDATE_USER_NAME";
export type UPDATE_USER_NAME = "UPDATE_USER_NAME";

export const UPDATE_DEAL_VEHICLES = "UPDATE_DEAL_VEHICLES";
export type UPDATE_DEAL_VEHICLES = "UPDATE_DEAL_VEHICLES";

export const SHOW_POWER_USER_TOOLS = "SHOW_POWER_USER_TOOLS";
export type SHOW_POWER_USER_TOOLS = "SHOW_POWER_USER_TOOLS";

export const UPDATE_CURRENT_DEAL = "UPDATE_CURRENT_DEAL";
export type UPDATE_CURRENT_DEAL = "UPDATE_CURRENT_DEAL";

export const UPDATE_SCHEDULE_APPOINTMENT = "UPDATE_SCHEDULE_APPOINTMENT";
export type UPDATE_SCHEDULE_APPOINTMENT = "UPDATE_SCHEDULE_APPOINTMENT";

export const REMOVE_SCHEDULE_APPOINTMENT = "REMOVE_SCHEDULE_APPOINTMENT";
export type REMOVE_SCHEDULE_APPOINTMENT = "REMOVE_SCHEDULE_APPOINTMENT";

export const CLEAR_ALL_EXCEPT_ACCOUNT = "CLEAR_ALL_EXCEPT_ACCOUNT";
export type CLEAR_ALL_EXCEPT_ACCOUNT = "CLEAR_ALL_EXCEPT_ACCOUNT";

export const CLEAR_ALL = "CLEAR_ALL";
export type CLEAR_ALL = "CLEAR_ALL";

export const SET_VIEWING_SCP_FORM = "SET_VIEWING_SCP_FORM";
export type SET_VIEWING_SCP_FORM = "SET_VIEWING_SCP_FORM";
